export const NAME = 'pronunciation' as const;

